import { IScreenModel } from '../interfaces';
import { SeatApiModel } from '../model/api-model/screen/seat/seat.api.model';
import { SeatViewModel } from '../model/view-model/screen/seat/seat.view.model';

export function seatInGroupComparer(rowSort: number): (a: SeatViewModel, b: SeatViewModel) => number {
  return (a, b) => {
    return rowSort === 1
      ? isNaN(Number(a.symbol))
        ? a.symbol.localeCompare(b.symbol)
        : Number(a.symbol) - Number(b.symbol)
      : isNaN(Number(a.symbol))
        ? b.symbol.localeCompare(a.symbol)
        : Number(b.symbol) - Number(a.symbol);
  };
}

export function getCoordinates(screenModel: IScreenModel, element: SeatApiModel) {
  const row = screenModel.rows.find((x) => x.id === element.rowId);
  const col = screenModel.cols.find((x) => x.id === element.colId);
  return {
    x: col.coordinate,
    y: row.coordinate,
    row,
    col
  };
}

/**
 * Removes cinema screen tags (DREAM, IMAX, etc.) from screen names
 * Removes the tag along with optional preceding dash and extra whitespace
 * Case-insensitive matching
 * @param screenName - The screen name to clean
 * @returns Cleaned screen name without tags
 */
export function removeScreenTags(screenName: string | null | undefined): string {
  if (!screenName) {
    return '';
  }

  const tags = ['DREAM', 'IMAX', 'VIP', '4DX', 'SCREENX', 'DOLBY'];
  let result = screenName;

  tags.forEach((tag) => {
    const pattern = new RegExp(`\\s*-?\\s*${tag}\\b`, 'gi');
    result = result.replace(pattern, '');
  });

  return result.trim();
}
